import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faEdit, faCheckCircle, faQuestionCircle, faListOl, faSave, faChevronRight } from '@fortawesome/free-solid-svg-icons';

class ConfiguracionEvaluaciones extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            evaluaciones: [],
            clasesPregunta: [],
            evaluacionSeleccionada: null,
            preguntaSeleccionada: null,
            formEvaluacion: { id: '', descripcion: '', estado: 1 },
            formPregunta: { id: '', nombre_pregunta: '', porcentaje: 0, clase_pregunta: '' },
            formRespuesta: { id: '', descripcion: '', score: 0 },
            loading: false
        };
    }

    componentDidMount() {
        this.cargarEvaluaciones();
        this.cargarClasesPregunta();
    }

    cargarEvaluaciones = () => {
        authAxios.get("evaluacion-config/listar")
            .then(res => this.setState({ evaluaciones: res.data }))
            .catch(err => console.error(err));
    }

    cargarClasesPregunta = () => {
        authAxios.get("evaluacion-config/clases-pregunta")
            .then(res => this.setState({ clasesPregunta: res.data }))
            .catch(err => console.error(err));
    }

    seleccionarEvaluacion = (id) => {
        this.setState({ loading: true });
        authAxios.get(`evaluacion-config/ver/${id}`)
            .then(res => {
                this.setState({
                    evaluacionSeleccionada: res.data,
                    preguntaSeleccionada: null,
                    formEvaluacion: { ...res.data.evaluacion },
                    loading: false
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                Swal.fire('Error', 'No se pudo cargar el detalle', 'error');
            });
    }

    seleccionarPregunta = (pregunta) => {
        this.setState({
            preguntaSeleccionada: pregunta,
            formPregunta: { ...pregunta }
        });
    }

    handleInputChange = (e, formName) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            [formName]: { ...prevState[formName], [name]: value }
        }));
    }

    guardarEvaluacion = () => {
        authAxios.post("evaluacion-config/guardar", this.state.formEvaluacion)
            .then(res => {
                Swal.fire('Éxito', res.data.msj, 'success');
                this.cargarEvaluaciones();
                if (res.data.id) this.seleccionarEvaluacion(res.data.id);
            })
            .catch(err => Swal.fire('Error', 'No se pudo guardar', 'error'));
    }

    guardarPregunta = () => {
        const payload = { ...this.state.formPregunta, evaluacion: this.state.evaluacionSeleccionada.evaluacion.id };
        authAxios.post("evaluacion-config/pregunta/guardar", payload)
            .then(res => {
                if (res.data.Status) {
                    Swal.fire('Éxito', res.data.msj, 'success');
                    this.seleccionarEvaluacion(payload.evaluacion);
                    this.resetForm('formPregunta');
                } else {
                    Swal.fire('Error', res.data.msj, 'error');
                }
            });
    }

    guardarRespuesta = () => {
        const payload = { ...this.state.formRespuesta, pregunta: this.state.preguntaSeleccionada.id };
        authAxios.post("evaluacion-config/respuesta/guardar", payload)
            .then(res => {
                if (res.data.Status) {
                    Swal.fire('Éxito', res.data.msj, 'success');
                    this.seleccionarEvaluacion(this.state.evaluacionSeleccionada.evaluacion.id);
                    // Refresh current question to show new answers
                    setTimeout(() => {
                        const updatedPregunta = this.state.evaluacionSeleccionada.preguntas.find(p => p.id === payload.pregunta);
                        this.setState({ preguntaSeleccionada: updatedPregunta });
                    }, 500);
                    this.resetForm('formRespuesta');
                } else {
                    Swal.fire('Error', res.data.msj, 'error');
                }
            });
    }

    eliminar = (tipo, id) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción no se puede deshacer",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, borrar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get(`evaluacion-config/eliminar/${tipo}/${id}`)
                    .then(res => {
                        Swal.fire('Eliminado', res.data.msj, 'success');
                        if (tipo === 'evaluacion') {
                            this.setState({ evaluacionSeleccionada: null, preguntaSeleccionada: null });
                            this.cargarEvaluaciones();
                        } else {
                            this.seleccionarEvaluacion(this.state.evaluacionSeleccionada.evaluacion.id);
                        }
                    });
            }
        });
    }

    resetForm = (name) => {
        const initial = {
            formPregunta: { id: '', nombre_pregunta: '', porcentaje: 0, clase_pregunta: '' },
            formRespuesta: { id: '', descripcion: '', score: 0 }
        };
        this.setState({ [name]: initial[name] });
    }

    render() {
        const { evaluaciones, clasesPregunta, evaluacionSeleccionada, preguntaSeleccionada, formEvaluacion, formPregunta, formRespuesta } = this.state;

        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="row">
                        {/* List of Evaluations */}
                        <div className="col-md-3">
                            <div className="card shadow-sm h-100 border-0" style={{ borderRadius: '15px' }}>
                                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center" style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}>
                                    <h5 className="mb-0 fw-bold small">Evaluaciones</h5>
                                    <button className="btn btn-light btn-xs text-primary" onClick={() => this.setState({ evaluacionSeleccionada: null, formEvaluacion: { id: '', descripcion: '', estado: 1 } })}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                </div>
                                <div className="list-group list-group-flush overflow-auto" style={{ maxHeight: '70vh' }}>
                                    {evaluaciones.map(e => (
                                        <button key={e.id} className={`list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center ${evaluacionSeleccionada?.evaluacion?.id === e.id ? 'bg-light fw-bold border-start border-4 border-primary' : ''}`} onClick={() => this.seleccionarEvaluacion(e.id)}>
                                            <div className="text-truncate me-2 small" dangerouslySetInnerHTML={{ __html: e.descripcion }}></div>
                                            <FontAwesomeIcon icon={faChevronRight} className="text-muted extra-small" />
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Detail / Config Area */}
                        <div className="col-md-9">
                            <div className="card shadow-sm border-0 h-100" style={{ borderRadius: '15px' }}>
                                <div className="card-body">
                                    {!evaluacionSeleccionada && !formEvaluacion.id ? (
                                        <div className="text-center py-5">
                                            <FontAwesomeIcon icon={faQuestionCircle} size="3x" className="text-muted mb-3" />
                                            <h5>Crear Nueva Evaluación</h5>
                                            <div className="col-md-6 mx-auto mt-4">
                                                <input type="text" className="form-control mb-2" name="descripcion" placeholder="Nombre de la evaluación..." value={formEvaluacion.descripcion} onChange={(e) => this.handleInputChange(e, 'formEvaluacion')} />
                                                <button className="btn btn-primary w-100" onClick={this.guardarEvaluacion}>Comenzar Configuración</button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            {/* Evaluation Header */}
                                            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                                                <div className="flex-grow-1 me-3">
                                                    <input type="text" className="form-control form-control-lg fw-bold border-0 bg-transparent p-0" name="descripcion" value={formEvaluacion.descripcion} onChange={(e) => this.handleInputChange(e, 'formEvaluacion')} placeholder="Nombre de la evaluación..." onBlur={this.guardarEvaluacion} />
                                                </div>
                                                <button className="btn btn-outline-danger btn-sm rounded-pill" onClick={() => this.eliminar('evaluacion', formEvaluacion.id)}>
                                                    <FontAwesomeIcon icon={faTrash} className="me-1" /> Borrar Evaluación
                                                </button>
                                            </div>

                                            <div className="row">
                                                {/* Questions Column */}
                                                <div className="col-md-6 border-end">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <h6 className="fw-bold mb-0 text-primary">Preguntas</h6>
                                                        <button className="btn btn-primary btn-xs rounded-pill" onClick={() => this.resetForm('formPregunta')}>
                                                            <FontAwesomeIcon icon={faPlus} className="me-1" /> Nueva
                                                        </button>
                                                    </div>

                                                    <div className="mb-4 p-3 bg-light rounded shadow-xs border">
                                                        <label className="extra-small fw-bold text-muted uppercase">Configurar Pregunta</label>
                                                        <input type="text" className="form-control form-control-sm mb-2" name="nombre_pregunta" placeholder="Enunciado de la pregunta..." value={formPregunta.nombre_pregunta} onChange={(e) => this.handleInputChange(e, 'formPregunta')} />
                                                        <div className="row g-2 mb-2">
                                                            <div className="col-6">
                                                                <select className="form-select form-select-sm" name="clase_pregunta" value={formPregunta.clase_pregunta} onChange={(e) => this.handleInputChange(e, 'formPregunta')}>
                                                                    <option value="">Tipo...</option>
                                                                    {clasesPregunta.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                                                                </select>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="input-group input-group-sm">
                                                                    <input type="number" className="form-control" name="porcentaje" placeholder="Weight %" value={formPregunta.porcentaje} onChange={(e) => this.handleInputChange(e, 'formPregunta')} />
                                                                    <span className="input-group-text">%</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-dark btn-sm w-100" onClick={this.guardarPregunta}>
                                                            <FontAwesomeIcon icon={faSave} className="me-2" /> {formPregunta.id ? 'Actualizar Pregunta' : 'Guardar Pregunta'}
                                                        </button>
                                                    </div>

                                                    <div className="list-group list-group-flush border rounded overflow-auto" style={{ maxHeight: '350px' }}>
                                                        {evaluacionSeleccionada.preguntas.map(p => (
                                                            <div key={p.id} className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center p-2 ${preguntaSeleccionada?.id === p.id ? 'bg-primary text-white shadow' : ''}`} onClick={() => this.seleccionarPregunta(p)} style={{ cursor: 'pointer' }}>
                                                                <div className="me-auto overflow-hidden">
                                                                    <div className="small text-truncate" title={p.nombre_pregunta}>{p.nombre_pregunta}</div>
                                                                    <div className={`extra-small ${preguntaSeleccionada?.id === p.id ? 'text-white-50' : 'text-muted'}`}>{p.tipo} • {p.porcentaje}%</div>
                                                                </div>
                                                                <button className="btn btn-link btn-xs text-danger p-0 ms-2" onClick={(e) => { e.stopPropagation(); this.eliminar('pregunta', p.id); }}>
                                                                    <FontAwesomeIcon icon={faTrash} className={preguntaSeleccionada?.id === p.id ? 'text-white' : ''} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Answers Column */}
                                                <div className="col-md-6">
                                                    {preguntaSeleccionada ? (
                                                        <div>
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <h6 className="fw-bold mb-0 text-success">Respuestas para Pregunta</h6>
                                                                <button className="btn btn-success btn-xs rounded-pill" onClick={() => this.resetForm('formRespuesta')}>
                                                                    <FontAwesomeIcon icon={faPlus} className="me-1" /> Nueva
                                                                </button>
                                                            </div>

                                                            <div className="mb-4 p-3 bg-light rounded shadow-xs border">
                                                                <label className="extra-small fw-bold text-muted uppercase">Configurar Respuesta</label>
                                                                <input type="text" className="form-control form-control-sm mb-2" name="descripcion" placeholder="Opción de respuesta..." value={formRespuesta.descripcion} onChange={(e) => this.handleInputChange(e, 'formRespuesta')} />
                                                                <div className="row g-2 mb-2">
                                                                    <div className="col-12">
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text">Puntaje</span>
                                                                            <input type="number" className="form-control" name="score" placeholder="Score..." value={formRespuesta.score} onChange={(e) => this.handleInputChange(e, 'formRespuesta')} />
                                                                            <span className="input-group-text">/ {preguntaSeleccionada.porcentaje}%</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <button className="btn btn-success btn-sm w-100" onClick={this.guardarRespuesta}>
                                                                    <FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Guardar Respuesta
                                                                </button>
                                                            </div>

                                                            <div className="list-group list-group-flush border rounded overflow-auto" style={{ maxHeight: '350px' }}>
                                                                {(evaluacionSeleccionada.preguntas.find(p => p.id === preguntaSeleccionada.id)?.respuestas || []).map(r => (
                                                                    <div key={r.id} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center p-2">
                                                                        <div className="me-auto">
                                                                            <div className="small">{r.descripcion}</div>
                                                                            <div className="extra-small text-muted">Puntaje: <span className={r.score > 0 ? 'text-success fw-bold' : ''}>{r.score}</span></div>
                                                                        </div>
                                                                        <div className="d-flex">
                                                                            <button className="btn btn-link btn-xs text-primary p-0 me-2" onClick={() => this.setState({ formRespuesta: { ...r } })}>
                                                                                <FontAwesomeIcon icon={faEdit} />
                                                                            </button>
                                                                            <button className="btn btn-link btn-xs text-danger p-0" onClick={() => this.eliminar('respuesta', r.id)}>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center py-5 text-muted">
                                                            <FontAwesomeIcon icon={faListOl} size="2x" className="mb-2 opacity-50" />
                                                            <div className="small">Seleccione una pregunta para ver sus respuestas</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfiguracionEvaluaciones;